import { Validation } from "../Validation/Validation";
export const fieldUser = [
    {
        id:"firstName",
        name:"firstName", 
        label:"First Name",
        type:"input",
        inputType:"text",
        errorMessage: "first name"
    },
    {
        id:"lastName",
        name:"lastName", 
        label:"Last Name",
        type:"input",
        inputType:"text",
        errorMessage: "last name"
    },
    {
        id:"email",
        name:"email", 
        label:"Email",
        type:"input",
        inputType:"text",
        errorMessage: "valid email address"
    },
    {
        id:"roleAssignment",
        name:"roleAssignment", 
        label:"Role Assignment",
        placeHolder: "Role",
        type:"select",
        errorMessage: "role assignment",
        data: [
            {value:"SUPER_ADMIN", label:"ADMIN"},
            {value:"MODERATOR", label:"VIEWER"},
        ]
    },    
    {
        id:"status",
        name:"status", 
        label:"Status",
        placeHolder: "Status",
        type:"select",
        data: [
            {value:"ACTIVE", label:"Active"},
            {value:"INACTIVE", label:"Inactive"},
            // {value:"PENDING", label:"Pending"},
        ]
    },    
]

export const REQUIRED_FIELDS = [
  "firstName",
  "lastName",
  "email",
  "roleAssignment",
  "status",
];

// --- Role Mapping ---
export const handleRolesString = (roles) => {
  switch (roles) {
    case "Admin":
      return "SUPER_ADMIN";
    case "Viewer":
      return "MODERATOR";
    case "Building Admin":
      return "BUILDING_ADMIN";
    case "Building Viewer":
      return "BUILDING_MODERATOR";
    default:
      return "";
  }
};

// --- Validation Function ---
export const handleValidation = (formData, actionButton, setFormError) => {
  let isValid = true;
  let errors = {};

  REQUIRED_FIELDS.forEach((field) => {
    if (actionButton === "add" && field === "status") return;
    if (Validation.empty(formData[field])) {
      isValid = false;
      const fieldObj = fieldUser.find((item) => item.name === field);
      errors[field] = `Please enter ${fieldObj?.errorMessage || field}`;
    }
  });

  if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    isValid = false;
    errors.email = "Please enter a valid email address";
  }

  if (!isValid) {
    setFormError(errors);
  } else {
    setFormError({});
  }

  return isValid;
};

// --- Payload Builders ---
export const buildAddPayload = (formData) => {
  return {
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    passKey: "string",
    telephone: "string",
    gender: "string",
    tenantId: 712,
    tenantName: "string",
    title: "None",
    roleName: handleRolesString(formData.roleAssignment),
    note: "Notes 1",
    userRoles: [handleRolesString(formData.roleAssignment)],
    userStatus: "PENDING",
  };
};

export const buildEditPayload = (formData, editData) => {
  return {
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    passKey: "string",
    telephone: editData.telephone || "string",
    gender: "string",
    tenantId: 712,
    tenantName: "string",
    title: "None",
    roleName: handleRolesString(formData.roleAssignment),
    note: "Notes 1",
    userRoles: [handleRolesString(formData.roleAssignment)],
    userStatus: formData.status,
  };
};

// --- Error Handler (including 409) ---
export const handleUserError = (userState, actionButton, setFormError) => {
  if (!userState.isLoading && userState.error !== "") {
    if (actionButton === "edit") {
      const errorData = userState.error?.data || {};
      setFormError({
        email: errorData.email || "",
        firstName: errorData.firstName || "",
        lastName: errorData.lastName || "",
        roleAssignment: errorData.roleAssignment || "",
        status: errorData.status || "",
      });
    }
  }
  if (userState.error?.status === 409 && actionButton === "edit") {
    setFormError({ email: "Please change customer email from customer management screen" });
  } else if (userState.error?.status === 409) {
    setFormError({ email: "User with the same email already exists" });
  }
};